import { SystemSettingKeysEnum } from "@/pages/taskpane/shared/types/enums/AppSettingKeysEnum";
import { NodeEntity } from "../../../search/services/entities/nodeEntity";
import { ResourceTypeEntity } from "../../../search/services/entities/resourceTypeEntity";

export class ConfigurationEntity {
    categories: NodeEntity[];
    locations: NodeEntity[];
    resourceTypes: ResourceTypeEntity[];
    helpUrlForOutLookAddin: string;
    parameters: {
        key: string;
        value: string;
    }[];
    meetingLabelConfiguration: MeetingLabelConfigEntity;

    constructor(data?: Partial<ConfigurationEntity>) {
        this.categories = data?.categories || [];
        this.locations = data?.locations || [];
        this.resourceTypes = data?.resourceTypes || [];
        this.helpUrlForOutLookAddin = data?.helpUrlForOutLookAddin || "";
        this.parameters = data?.parameters || [];
        this.meetingLabelConfiguration = new MeetingLabelConfigEntity(data?.meetingLabelConfiguration);
    }

    get parametersFormatted(): ParameterEntity {
        let resourceFinderAssistantOrganizer = false
        let daysReserved = 0;
        let stopMovingOrder = false;
        let floorplan = false;
        let dateFormat = "dd-MM-yyyy";
        let timeFormat = "HH:mm";
        let dateSeperator = "";
        let firstDayOfWeek = 0;
        let isEnableLocationCheckbox = true;
        let outlookAddinTimeLineVisible = true;
        let orderForm = false;

        // Resource finder assistant organizer

        const resourceFinderAssistantOrganizerParameter = this.parameters.find((parameter) => parameter.key === SystemSettingKeysEnum.ResourceFinderAssistantOrganizer);
        if (resourceFinderAssistantOrganizerParameter) {
            resourceFinderAssistantOrganizer = ("1" === resourceFinderAssistantOrganizerParameter.value);
        }

        // Order deadline stop moving order

        const stopMovingOrderParameter = this.parameters.find((parameter) => parameter.key === SystemSettingKeysEnum.OrderDeadlineStopMovingOrder);
        if (stopMovingOrderParameter) {
            stopMovingOrder = ("1" === stopMovingOrderParameter.value) ? true : false;
        }

        // Priority reservation days reserved

        const daysReservedParameter = this.parameters.find((parameter) => parameter.key === SystemSettingKeysEnum.PriorityReservationDaysReserved);
        if (daysReservedParameter) {
            daysReserved = parseInt(daysReservedParameter.value) ?? 0;
        }

        // Floorplan
        const floorplanParameter = this.parameters.find((parameter) => parameter.key === SystemSettingKeysEnum.ResourceFinderFloorPlan);
        if (floorplanParameter) {
            floorplan = ("1" === floorplanParameter.value) ? true : false;
        }

        // Date time format
        const dateFormatParameter = this.parameters.find((parameter) => parameter.key === SystemSettingKeysEnum.DateFormat);
        if (dateFormatParameter) {
            dateFormat = dateFormatParameter.value;
        }
        const timeFormatParameter = this.parameters.find((parameter) => parameter.key === SystemSettingKeysEnum.TimeFormat);
        if (timeFormatParameter) {
            timeFormat = timeFormatParameter.value;
        }
        const dateSeperatorParameter = this.parameters.find((parameter) => parameter.key === SystemSettingKeysEnum.DateSeperator);
        if (dateSeperatorParameter) {
            dateSeperator = dateSeperatorParameter.value;
        }
        const firstDayOfWeekParameter = this.parameters.find((parameter) => parameter.key === SystemSettingKeysEnum.DefaultFirstDayOfWeek);
        if (firstDayOfWeekParameter) {
            firstDayOfWeek = parseInt(firstDayOfWeekParameter.value) ?? 0;
        }

         // Is enable location checkbox
        //  const isEnableLocationCheckboxParameter = this.parameters.find((parameter) => parameter.key === SystemSettingKeysEnum.IsEnableLocationCheckbox);
        //  if (isEnableLocationCheckboxParameter) {
        //      isEnableLocationCheckbox = "1" === isEnableLocationCheckboxParameter.value;
        //  }

        // Outlook addin time line visible
        const outlookAddinTimeLineVisibleParameter = this.parameters.find((parameter) => parameter.key === SystemSettingKeysEnum.OutlookAddinTimeLineVisible);
        if (outlookAddinTimeLineVisibleParameter) {
            outlookAddinTimeLineVisible = "1" === outlookAddinTimeLineVisibleParameter.value;
        }

        // Order form
        const orderFormParameter = this.parameters.find((parameter) => parameter.key === SystemSettingKeysEnum.ResourceFinderOrderFormVisible);
        if (orderFormParameter) {
            orderForm = ("1" === orderFormParameter.value) ? true : false;
        }

        // Return all parameters
        return {
            resourceFinderAssistantOrganizer: resourceFinderAssistantOrganizer,
            daysReserved: daysReserved,
            stopMovingOrder: stopMovingOrder,
            floorplan: floorplan,
            firstDayOfWeek: firstDayOfWeek,
            dateFormat: dateFormat,
            timeFormat: timeFormat,
            dateSeperator: dateSeperator,
            isEnableLocationCheckbox: isEnableLocationCheckbox,
            outlookAddinTimeLineVisible: outlookAddinTimeLineVisible,
            orderForm: orderForm,
        };
    }
}

export class ParameterEntity {
    resourceFinderAssistantOrganizer: boolean;
    daysReserved: number;
    stopMovingOrder: boolean;
    floorplan: boolean;
    firstDayOfWeek: number;
    dateFormat: string;
    timeFormat: string;
    dateSeperator: string;
    isEnableLocationCheckbox: boolean;
    outlookAddinTimeLineVisible: boolean;
    orderForm: boolean;

    constructor(data?: Partial<ParameterEntity>) {
        this.resourceFinderAssistantOrganizer = data?.resourceFinderAssistantOrganizer ?? false;
        this.daysReserved = data?.daysReserved ?? 0;
        this.stopMovingOrder = data?.stopMovingOrder ?? false;
        this.floorplan = data?.floorplan ?? false;
        this.firstDayOfWeek = data?.firstDayOfWeek ?? 0;
        this.dateFormat = data?.dateFormat ?? "dd-MM-yyyy";
        this.timeFormat = data?.timeFormat ?? "HH:mm";
        this.dateSeperator = data?.dateSeperator ?? "";
        this.isEnableLocationCheckbox = data?.isEnableLocationCheckbox ?? true;
        this.outlookAddinTimeLineVisible = data?.outlookAddinTimeLineVisible ?? true;
        this.orderForm = !!data?.orderForm;
    }
}

export class MeetingLabelConfigEntity {
    isUseMeetingLabel: boolean;
    isRequired: boolean;
    colorInBookingManagerType: number;
    caption: string;
    meetingLabels: MeetingLabelEntity[];

    constructor(data?: Partial<MeetingLabelConfigEntity>) {
        this.isUseMeetingLabel = data?.isUseMeetingLabel ?? false;
        this.isRequired = data?.isRequired ?? false;
        this.colorInBookingManagerType = data?.colorInBookingManagerType ?? 0;
        this.caption = data?.caption ?? "";
        this.meetingLabels = data?.meetingLabels ?? [];
    }
}

export class MeetingLabelEntity {
    id: number;
    name: string;
    color: string;
    isDisplayDefault: boolean;
    isLightColor: boolean;

    constructor(data?: Partial<MeetingLabelEntity>) {
        this.id = data?.id ?? 0;
        this.name = data?.name ?? "";
        this.color = data?.color ?? "";
        this.isDisplayDefault = data?.isDisplayDefault ?? false;
        this.isLightColor = data?.isLightColor ?? false;
    }
}